import {useMemo} from 'react';

import {RejectionRates} from '../types/RecruitingDashboardTypes';

import {useGetRequest} from '../../../../../hooks/useGetRequest';
import {getRejectionRates} from '../../../../../lib/api/v1';
import {SerializeTo} from '../../../../../utils/serializer/serialize';

export const useRejectionRates = (companyId: string) => {
  const fetchRejectionRates = useMemo(() => {
    return () => getRejectionRates(companyId);
  }, [companyId]);

  const {data, loading, error} = useGetRequest(fetchRejectionRates, SerializeTo.CamelCase<RejectionRates>);

  return {
    data,
    loading,
    error,
  };
};
